/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProcedureItem } from '../../models/procedure-item';

export interface ProcedureControllerGetOne$Params {
  id: number;
}

export function procedureControllerGetOne(http: HttpClient, rootUrl: string, params: ProcedureControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>> {
  const rb = new RequestBuilder(rootUrl, procedureControllerGetOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProcedureItem;
      }>;
    })
  );
}

procedureControllerGetOne.PATH = '/procedure/{id}';
